import { IPublicationDetailResponse } from "../../../model/base/response/publication-response";

export interface IPublicationDetailState {
    publicationDetail: IPublicationDetailResponse | null;
    loading: boolean;
    error: string | null;
}

export const initialState: IPublicationDetailState = {
    publicationDetail: null,
    loading: false,
    error: null
};

export enum ACTION_TYPES {
    SET_LOADING = 'SET_LOADING',
    SET_PUBLICATION_DETAIL = 'SET_PUBLICATION_DETAIL',
    SET_ERROR = 'SET_ERROR'
}

export const PublicationDetailReducer = (state: IPublicationDetailState, action: any): IPublicationDetailState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.SET_LOADING:
            return {
                ...state,
                loading: payload
            };
        case ACTION_TYPES.SET_PUBLICATION_DETAIL:
            return {
                ...state,
                publicationDetail: payload,
                loading: false,
                error: null
            };
        case ACTION_TYPES.SET_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
